import { Card, Statistic } from 'antd';
import type { ReactNode } from 'react';

export function KpiCard({ label, value, trend, onClick }: { label: string; value: ReactNode; trend?: string; onClick?: () => void }) {
  return (
    <Card className="kpi-card" size="small" hoverable={Boolean(onClick)} onClick={onClick} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined} styles={{ body: { padding: '12px 16px' } }}>
      <Statistic title={<span className="kpi-label">{label}</span>} value={typeof value === 'number' ? value : undefined} formatter={typeof value === 'number' ? undefined : () => <span className="kpi-value">{value}</span>} styles={{ content: { fontSize: 24, fontWeight: 700 } }} />
      {trend ? <div className="kpi-trend">{trend}</div> : null}
    </Card>
  );
}
